import EmberRouter from '@ember/routing/router';
import ENV from 'frontend-login/config/environment';

export default class Router extends EmberRouter {
  location = ENV.locationType;
  rootURL = ENV.rootURL;
}

Router.map(function () {
  this.route('firebase', { path: '/' }, function () {
    this.route('change-email', {
      path: '/change-email/:code/',
      resetNamespace: true,
    });
    this.route('login', { resetNamespace: true });
    this.route('mfa', { resetNamespace: true });
    this.route('password-reset', { resetNamespace: true });
    this.route('register', { resetNamespace: true });
    this.route('register-email-sent', { resetNamespace: true });
  });
});
